module.exports = __webpack_public_path__ + "img/checkGrande.466b915f.svg";